export default "__VITE_ASSET__CJ4FLTj___"